module.exports = __webpack_public_path__ + "static/media/analytics_insights.b0f222d3.png";